import { ChangeEvent } from 'react';
import { flow } from 'fp-ts/function';
import { left, right, fold } from 'fp-ts/Either';
import { tryCatch, leftTask, fold as foldTE } from 'fp-ts/TaskEither';
import { of } from 'fp-ts/Task';
import { ErrorCode, IError } from '..';

export interface ReadFileResponse {
  filename: string;
  content: string;
}

export const getFile = (e: ChangeEvent<HTMLInputElement>) => {
  const a = e.target && e.target.files && e.target.files[0];
  return a === null ? left('no file') : right(a);
  //   return a === null ? left('no file') : left('no file 1');
};

const readFile = (file: File): Promise<ReadFileResponse> =>
  new Promise((res, rej) => {
    var reader = new FileReader();

    reader.onload = function (e) {
      var contents = e.target && e.target.result;
      res({
        filename: file.name,
        content: contents as string,
      });
      //   rej({ code: ErrorCode.ReadFileError, message: contents as string });
    };
    reader.onerror = a =>
      rej({ code: ErrorCode.ReadFileError, message: 'readFile error' });

    reader.readAsText(file);
  });

const tryReadFile = (file: File) =>
  tryCatch(readFile.bind(null, file), (e: any) => {
    return {
      code: e.code as ErrorCode,
      message: e.message as string,
    };
  });

const read = flow(
  getFile,
  fold(
    e => leftTask(of({ code: ErrorCode.NoFile, message: e })),
    file => tryReadFile(file)
  )
);

export const readAsText = flow(
  read,
  foldTE<IError, ReadFileResponse, ReadFileResponse | IError>(
    error => () => Promise.reject(error),
    a => () => Promise.resolve(a)
  )
);
